import React from 'react';
import { Button } from '../ui';

/**
 * Last line of defence: an unexpected render error shows a recoverable message instead of a blank page.
 * (Request failures are handled by each screen's own error state; this is for genuine bugs.)
 */
export class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Hook for an error-reporting service when one is chosen; for now keep the details in the console.
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error, info && info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" className="grid min-h-screen place-items-center bg-canvas px-4 text-center">
        <div className="max-w-sm">
          <h1 className="text-xl font-bold text-ink">Something went wrong</h1>
          <p className="mb-5 mt-2 text-sm text-muted">An unexpected error stopped this page from loading. Reloading usually fixes it.</p>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </div>
      </main>
    );
  }
}
